var map = {
	"./01_tn.jpg": 490,
	"./02_tn.jpg": 491,
	"./03_tn.jpg": 492,
	"./04_tn.jpg": 493,
	"./05_tn.jpg": 494,
	"./06_tn.jpg": 495,
	"./07_tn.jpg": 496,
	"./08_tn.jpg": 497,
	"./09_tn.jpg": 498,
	"./10a_tn.jpg": 499,
	"./10b_tn.jpg": 500,
	"./11_tn.jpg": 501,
	"./12_tn.jpg": 502,
	"./13_tn.jpg": 503,
	"./16_tn.jpg": 504,
	"./17_tn.jpg": 505,
	"./18_tn.jpg": 506,
	"./19_tn.jpg": 507,
	"./20_tn.jpg": 508,
	"./21_tn.jpg": 509,
	"./22_tn.jpg": 510,
	"./23_tn.jpg": 511,
	"./24_tn.jpg": 512,
	"./25_tn.jpg": 513,
	"./26_tn.jpg": 514,
	"./27_tn.jpg": 515,
	"./28_tn.jpg": 516,
	"./29_tn.jpg": 517,
	"./30_tn.jpg": 518,
	"./31_tn.jpg": 519,
	"./32_tn.jpg": 520,
	"./33_tn.jpg": 521,
	"./34_tn.jpg": 522,
	"./35_tn.jpg": 523,
	"./36_tn.jpg": 524,
	"./37_tn.jpg": 525,
	"./38_tn.jpg": 526,
	"./39_tn.jpg": 527,
	"./40_tn.jpg": 528,
	"./41_tn.jpg": 529,
	"./42_tn.jpg": 530,
	"./43_tn.jpg": 531,
	"./44_tn.jpg": 532,
	"./45_tn.jpg": 533,
	"./46_tn.jpg": 534,
	"./47_tn.jpg": 535,
	"./48_tn.jpg": 536,
	"./49_tn.jpg": 537,
	"./50_tn.jpg": 538,
	"./51_tn.jpg": 539,
	"./52_tn.jpg": 540,
	"./53_tn.jpg": 541,
	"./54_tn.jpg": 542,
	"./55_tn.jpg": 543,
	"./56_tn.jpg": 544,
	"./57_tn.jpg": 545,
	"./58_tn.jpg": 546,
	"./60_tn.jpg": 547,
	"./61_tn.jpg": 548,
	"./62_tn.jpg": 549,
	"./63_tn.jpg": 550,
	"./64_tn.jpg": 551,
	"./65_tn.jpg": 552,
	"./66_tn.jpg": 553,
	"./67_tn.jpg": 554,
	"./69_tn.jpg": 555,
	"./70_tn.jpg": 556,
	"./71_tn.jpg": 557,
	"./72_tn.jpg": 558,
	"./73_tn.jpg": 559,
	"./75_tn.jpg": 560,
	"./76_tn.jpg": 561
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 489;


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails nonrecursive \.(png|jpe?g|svg)$
// module id = 489
// module chunks = 0